import React from 'react';
import { useTranslation } from 'react-i18next';

import enImage from '../assets/icons/EN.svg'; // English flag/icon
import arImage from '../assets/icons/AR.svg'; // Arabic flag/icon

const LanguageTranslation = ({ className }) => {
  const { i18n } = useTranslation();

  const currentLang = i18n.language;

  const toggleLanguage = () => {
    const newLang = currentLang === 'ar' ? 'en' : 'ar';
    i18n.changeLanguage(newLang);
  };

  return (
    <div className={`language-toggle ${className}`} onClick={toggleLanguage} style={{ cursor: 'pointer' }}>
      <img
        src={currentLang === 'ar' ? arImage : enImage}
        alt={currentLang}
        width="50"
        height="25"
        style={{ borderRadius: '4px' }}
      />
    </div>
  );
};

export default LanguageTranslation;
